import { useEffect, useMemo, useState } from 'react';
import { auth, firestoreDb } from 'src/api/client';
import { doc, onSnapshot } from 'firebase/firestore';
import type { SubscriptionInfo } from '../types';
import { LocationsCollection, UsersCollection } from 'src/api/collections';

export function useLocationSubscriptionDoc(locationKey?: string | null) {
  const [info, setInfo] = useState<SubscriptionInfo | undefined>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const user = auth.currentUser;
    if (!user || !locationKey) {
      setLoading(false);
      setInfo(undefined);
      return;
    }

    const ref = doc(
      firestoreDb,
      `${UsersCollection}/${user.uid}/${LocationsCollection}/${locationKey}/billing/subscription`,
    );
    const unsub = onSnapshot(ref, snap => {
      setInfo(
        snap.exists() ? (snap.data() as SubscriptionInfo) : { status: 'none' },
      );
      setLoading(false);
    });
    return () => unsub();
  }, [locationKey]);

  const hasActiveSubscription =
    info?.status === 'active' ||
    info?.status === 'trialing' ||
    info?.status === 'past_due';

  return useMemo(
    () => ({ info, loading, hasActiveSubscription }),
    [info, loading, hasActiveSubscription],
  );
}
